import { FiAppSettings } from '@fi-shared/fi-app-settings';

export class GlobalSearchParameterModel {
    constructor() {}
    GlobalSearchText = '';
    Offset = 0;
    NumberOfRecordsToTake = FiAppSettings.NumberOfRecordsPerPageForGlobalSearch;
    ContentLanguageId = 0;

    IsSearchingByTagName: boolean = false;
    SearchText: string;
}
